(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .component('painelMaquinasWrapper', {
      templateUrl: 'views/propriedade/maquinas-wrapper.html',
      controller: 'PainelMaquinasWrapperCtrl'
    });
}());
